
import React from 'react';

export const TeamHero: React.FC = () => {
  return (
    <div className="pt-16 pb-12 bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold font-display mb-6">Our Team</h1>       
          <p className="text-xl text-gray-300">Meet the dedicated instructors who make OMAC-UK exceptional</p>
        </div>
      </div>
    </div>
  );
};
